module.exports = __webpack_public_path__ + "static/media/phone_03.6f482225.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/phone_03.png
// module id = 1833
// module chunks = 0 1